import { render, staticRenderFns } from "./dataflowTask.vue?vue&type=template&id=450893a1&scoped=true"
import script from "./dataflowTask.vue?vue&type=script&lang=js"
export * from "./dataflowTask.vue?vue&type=script&lang=js"
import style0 from "./dataflowTask.vue?vue&type=style&index=0&id=450893a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450893a1",
  null
  
)

export default component.exports